var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgScorm = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 48, height: 33 }, props, { children: [_jsx("g", __assign({ "data-name": "Group 217" }, { children: _jsx("path", { "data-name": "Path 162", d: "M13.218 4.026A16.59 16.59 0 0 1 24 0a15.409 15.409 0 0 1 15.5 13.737A9.669 9.669 0 0 1 38.061 33H11.343a11.026 11.026 0 0 1-2.517-21.825 12.617 12.617 0 0 1 4.392-7.149Z", fill: "currentColor" }) })), _jsx("text", __assign({ "data-name": "SCORM", transform: "translate(9 23)", fill: "none", fontSize: 8, fontFamily: "Lato-Bold, Lato", fontWeight: 700, letterSpacing: ".05em" }, { children: _jsx("tspan", __assign({ x: 0, y: 0 }, { children: "SCORM" })) }))] }))); };
export default SvgScorm;
